import { RedirectType } from '@/models/redirects.model';

export enum RedirectsFiltersFields {
  TYPE = 'type',
  SOURCE = 'source',
  TARGET = 'target',
}

export enum RedirectsFormFieldsNames {
  TYPE = 'type',
  SOURCE = 'source',
  TARGET = 'target',
}

export type TRedirectFormValues = {
  [RedirectsFormFieldsNames.TYPE]: RedirectType;
  [RedirectsFormFieldsNames.SOURCE]: string;
  [RedirectsFormFieldsNames.TARGET]: string;
};

export type TGetRedirectsQuery = {
  [RedirectsFiltersFields.TYPE]?: RedirectType;
  [RedirectsFiltersFields.SOURCE]?: string;
  [RedirectsFiltersFields.TARGET]?: string;
};
